import { documentFilename } from './documentFilename';
export { documentFilename } from './documentFilename';
// import { Ref } from 'vue';
import dayjs from 'dayjs';
import { requestUrl, ossUrl } from '@/config/app';
import { isIE9 } from '@/utils/tool';

const getBlob = (url) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.timeout = 120000;
    xhr.onerror = () => reject(new Error('文件下载失败，请检查网络后重试'));
    xhr.ontimeout = () => reject(new Error('文件下载超时，请重试'));
    xhr.onabort = () => reject(new Error('文件下载已取消'));
    xhr.onload = () => {
      if (xhr.status === 200) {
        resolve(xhr.response);
      } else {
        reject(new Error(`文件下载失败（HTTP ${xhr.status}）`));
      }
    };

    xhr.send();
  });
};
const saveAs = (blob, filename) => {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, filename);
  } else {
    const link = document.createElement('a');
    const body = document.querySelector('body');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    // fix Firefox
    link.style.display = 'none';
    // @ts-ignore
    body.appendChild(link);
    link.click();
    // @ts-ignore
    body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  }
};
export const downloadFilename = (title, extension) => `${title}${dayjs().format('YYMMDDHHmm')}.${extension}`;

// Generated reports and ZIP archives are returned by the API as short-lived
// signed URLs from the unified private store.  They must never be prefixed
// with the legacy public OSS hostname.  The relative-path branch only keeps
// local development and an already-generated legacy local archive usable.
export const temporaryDownloadUrl = (value) => {
  const url = String(value || '').trim();
  if (!url) throw new Error('服务端未返回下载地址');
  if (/^https?:\/\//i.test(url)) return url;
  const base = String(requestUrl || '').replace(/\/+$/, '') + '/';
  return base + url.replace(/^\/+/, '');
};

// OSS v1 signatures encode the complete object key in the URL path. Decode
// before taking the final segment so a saved file never contains its path.
export const temporaryDownloadFilename = (value, fallback = '下载文件') => {
  const path = String(value || '').trim().split(/[?#]/, 1)[0];
  if (!path) return fallback;
  let decoded = path;
  try { decoded = decodeURIComponent(path); } catch (error) { /* use raw path */ }
  return decoded.split('/').filter(Boolean).pop() || fallback;
};

export const downloadUrl = async (url, fileName) => {
  const blob = await getBlob(url);
  saveAs(blob, fileName);
};

export const download = async (info, typeID) => {
  
  const filename = documentFilename(!typeID ? '合同' : '保函', info);
  let url = '';
  if (info.status == 5 || info.status == 13 || info.status == 7) {
    url = ossUrl + (!typeID ? info.sign_file_path : info.sign_file_path2);
  } else {
    url = ossUrl + (!typeID ? info.file_path : info.file_path2);
  }
  if (isIE9()) {
    window.location.href = url;
  } else {
    await downloadUrl(url, filename);
  }
};
